import { render, staticRenderFns } from "./EditorController.vue?vue&type=template&id=2e67e68a&scoped=true"
import script from "./EditorController.vue?vue&type=script&lang=ts"
export * from "./EditorController.vue?vue&type=script&lang=ts"
import style0 from "./EditorController.vue?vue&type=style&index=0&id=2e67e68a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e67e68a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e67e68a')) {
      api.createRecord('2e67e68a', component.options)
    } else {
      api.reload('2e67e68a', component.options)
    }
    module.hot.accept("./EditorController.vue?vue&type=template&id=2e67e68a&scoped=true", function () {
      api.rerender('2e67e68a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/EditorController.vue"
export default component.exports